import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IButton} from '@interfaces/elements';
import {UsuarioPermissaoService} from '@services/usuario-permissao.service';
import _sortBy from 'lodash/sortBy';
import {interval, Subscription} from 'rxjs';
import {exhaustMap, finalize, retry, take, tap} from 'rxjs/operators';
import {LocalStorageDecorator} from 'src/app/libs/local-storage-decorator';
import {BaseFormService} from 'src/app/services/base-form.service';

import {GerarPlanilhaDadosService} from './../../services/gerar-planilha-dados.service';
import {DadosUsuarioService} from "@services/dados-usuario.service";
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertSucessoPadraoComponent } from '../../components/alert-sucesso-padrao/alert-sucesso-padrao.component';
import { AlertErroPadraoComponent } from '../../components/alert-erro-padrao/alert-erro-padrao.component';
import { AlertDescartarAlteracoesComponent } from '../../components/alert-descartar-alteracoes/alert-descartar-alteracoes.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-gerar-planilha-dados',
    templateUrl: './gerar-planilha-dados.component.html',
    styleUrls: ['./gerar-planilha-dados.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertSucessoPadraoComponent, AlertErroPadraoComponent, AlertDescartarAlteracoesComponent, BreadcrumbComponent, SelectOneComponent, NgClass, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class GerarPlanilhaDadosComponent
  extends BaseFormService
  implements OnInit, OnDestroy {
  public empresa: any = localStorage.idEmpresaLogada;
  public pipeName = 'upperCase';

  public flagAtivos: any;
  public idDepart: any;
  public idEndere: any;
  public idEstado: any;
  public idCidade: any;

  public departamentos: any = [];
  public enderecos: any = [];
  public enderecosOptions: any = [];
  public enderecosFiltered: any = [];
  public ufList: any = [];
  public cidadesList: any = [];
  public cidadesFiltered: any = [];

  public loadingGenerico = false;
  public loadingGenericoData = {
    buttons: [] as Array<IButton>,
  };

  loadingGenericoMessage: string;

  fileNamePending: string;

  @LocalStorageDecorator() idDownload: string;

  public erro = false;
  public falhaPesquisa = false;
  public mensagemErro: any =
    'Ocorreu um erro ao gerar a planilha com os parâmetros passados.';

  subscriptions = new Subscription();
  public tipoPlanilha: any;
  showAlertSucesso: any;
  showAlertErro: any;
  showAlertDescarte: any;

  constructor(
    private readonly gerarPlanilhaDadosService: GerarPlanilhaDadosService,
    public readonly usuarioPermissaoService: UsuarioPermissaoService,
    private readonly dadosUsuarioService: DadosUsuarioService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.idDownload) {
      this.watchFileGenerationStatus();
    }
    this.getDepartamento();
    this.getEnderecos();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getEnderecos() {
    this.loadingGenerico = true;

    this.gerarPlanilhaDadosService.getEnderecos(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.enderecos = _sortBy(success.response, endereco => endereco.descricaoLogradouro);
        this.enderecosOptions = this.enderecos.map((end) => {
          const part1 = [
            end.descricaoLogradouro,
            end.codigoNumero,
            end.codigoComplemento
          ]
            .map(e => (e ?? '').trim())
            .filter(Boolean)
            .join(', ');

          const part2 = [
            end.codigoBairro,
            end.codigoCidade,
            end.codigoEstado,
            end.codigoCep,
          ]
            .map(e => (e ?? '').trim())
            .filter(Boolean)
            .join(' - ');

          return {
            id: end.idEndereco,
            label: `${part1} ${part2}`,
            codigoEstado: end.codigoEstado,
            codigoCidade: this.removerAcentos(end.codigoCidade.toUpperCase())
          };
        });
        this.enderecosFiltered = this.enderecosOptions;
        this.erro = false;
        this.generateUFList();
        this.generateCidadeList();
      },
      error: () => {
        this.erro = true;
      },
      complete: () => {
        if (!this.idDownload) {
          this.loadingGenerico = false;
        }
      }
    });
  }

  generateUFList(): void {
    this.dadosUsuarioService.getAllUfs().pipe(take(1))
    .subscribe({
      next: (response: any) => {
        const ufDistinctSet = new Set(response.response.map(x => x.codigoEstado));
        const ufDistinct: any = Array.from(ufDistinctSet);
        const ufSorted = ufDistinct.toSorted();
        this.ufList = ufSorted.map(x => ({
          id: x,
          label: x
        }));
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }


  generateCidadeList(): void {
    const cidadeEstrutura = this.enderecos.map(x => {
      return {
        codigoCidade: this.removerAcentos(x.codigoCidade.toUpperCase()),
        codigoEstado: x.codigoEstado
      };
    });
    const cidadeDistinctSet = new Set(cidadeEstrutura.map(JSON.stringify));
    let cidadeDistinct: any = Array.from(cidadeDistinctSet);
    cidadeDistinct = cidadeDistinct.toSorted();
    cidadeDistinct = cidadeDistinct.map(JSON.parse);
    this.cidadesList = cidadeDistinct.map(x => {
      return {
        id: x.codigoCidade,
        label: x.codigoCidade,
        codigoEstado: x.codigoEstado
      };
    });
    this.cidadesFiltered = this.cidadesList;
  }

  onChangeEstado(event): void {
    this.idEstado = event;
    if (this.idEstado === '0') {
      this.enderecosFiltered = this.enderecosOptions;
      this.cidadesFiltered = this.cidadesList;
    } else {
      this.cidadesFiltered = this.cidadesList.filter(x => x.codigoEstado === this.idEstado);
      this.enderecosFiltered = this.enderecosOptions.filter(x => x.codigoEstado === this.idEstado);
    }
    this.idCidade = undefined;
    this.idEndere = undefined;
  }

  onChangeCidade(event): void {
    this.idCidade = event;
    if (this.idCidade === '') {
      this.onChangeEstado(this.idEstado);
    } else {
      this.enderecosFiltered = this.enderecosOptions.filter(x => x.codigoCidade === this.idCidade);
      this.idEndere = undefined;
    }
  }

  removerAcentos(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  getDepartamento() {
    this.loadingGenerico = true;
    this.gerarPlanilhaDadosService.getDepartamento(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        this.departamentos = this.mapearResultados(
          success.response,
          'idDepartamento',
          'descDepartamento'
        );
        this.erro = false;
      },
      error: (error) => {
        this.erro = true;
      },
      complete: () => {
        if (!this.idDownload) {
          this.loadingGenerico = false;
        }
      }
    });
  }

  startFileGeneration(tipoArquivo: any) {
    this.loadingGenerico = true;
    const paramsArray = this.getParamsFormatArray(tipoArquivo);
    const paramsUrl = this.getParamsUrl(paramsArray);
    this.gerarPlanilhaDadosService.startFileGeneration(this.empresa, paramsUrl)
    .pipe(finalize(() => {
        this.watchFileGenerationStatus();
     }))
    .subscribe({
      next: ({ response: { idDownload } }) => {
        this.idDownload = idDownload;
        this.loadingGenericoMessage = 'Por favor, aguarde enquanto seu arquivo é gerado...';
      },
      error: () => {
        this.loadingGenericoMessage =
          'Já existe uma planilha sendo gerada, aguarde enquanto recuperamos essas informações...';
      }
    });
  }

  private watchFileGenerationStatus() {
    this.loadingGenerico = true;

    const subscription = interval(3000)
      .pipe(
        exhaustMap(() => this.gerarPlanilhaDadosService
          .getFileGenerationStatus(this.idDownload, this.tipoPlanilha)
          .pipe(retry(10)),
        ),
        tap((response: any) => {
          const endedFileGeneration = ['NOK', 'OK']
            .includes(response?.status);
          if (endedFileGeneration) {
            this.loadingGenericoData.buttons.length = 0;
          } else {
            this.loadingGenericoData.buttons[0] = {
              content: 'Cancelar',
              ngClass: 'btn btn-danger',
              click: (e) => {
                e.preventDefault();
                subscription.unsubscribe();
                this.loadingGenericoData.buttons.length = 0;
                this.loadingGenerico = false;
                this.idDownload = undefined;
              },
            };
          }
        }),
      )
      .subscribe({
        next: ({ response }: any) => {
          this.loadingGenerico = true;

          if (!response?.status || response?.status === 'ERRO') {
          this.idDownload = undefined;
          this.loadingGenericoMessage = null;
          this.loadingGenerico = false;
          this.showAlertErro = true;
          subscription.unsubscribe();
        } else if (response?.status === 'FINALIZADO') {
          this.fileNamePending = response?.nomeArquivo;
          this.loadingGenericoMessage = null;
          subscription.unsubscribe();
          this.loadingGenerico = false;
          this.idDownload = undefined;
          window.open(response?.urlDownload);
        } else {
          this.loadingGenericoMessage = 'Por favor, aguarde enquanto seu arquivo é gerado...';
        }
        }, error: (error) => {
          this.showAlertErro = true;
        }
      })
    this.subscriptions.add(subscription);
  }

  getParamsFormatArray(tipoArquivo: any) {
    const arr = [];

    arr.push({name: 'flagAtivos', comparator: '=', value: this.flagAtivos ?? 'T'}, {
      name: 'idDepart',
      comparator: '=',
      value: this.idDepart ?? '0'
    }, {name: 'idEndere', comparator: '=', value: this.idEndere ?? '0'}, {
      name: 'tipo',
      comparator: '=',
      value: tipoArquivo
    });
    if (this.idCidade !== '') {
      arr.push({name: 'idCidade', comparator: '=', value: this.idCidade ?? '0'});
    }
    if (this.idEstado !== '') {
      arr.push({name: 'idEstado', comparator: '=', value: this.idEstado ?? '0'});
    }
    return arr;
  }

  fecharAlertErro() {
    this.falhaPesquisa = false;
  }

  campoFiltroPreenchido() {
    return this.idCidade ??
      this.idEndere ??
      this.idEstado ??
      this.idDepart ??
      this.flagAtivos;
  }

  limparFiltro() {
    this.idCidade = undefined;
    this.idEndere = undefined;
    this.idEstado = undefined;
    this.idDepart = undefined;
    this.flagAtivos = undefined;
    this.enderecosFiltered = this.enderecosOptions;
    this.cidadesFiltered = this.cidadesList;
    this.fecharAlertDescartarAleracoes();
  }

  fecharAlertDescartarAleracoes() {
    this.showAlertDescarte = false;
  }

  sucessoFechou() {
    this.showAlertSucesso = false;
  }

  alertaErroFechou() {
    this.showAlertErro = false;
  }
}
